import { render } from "./ParentProductValue.vue?vue&type=template&id=f7a26824"
import script from "./ParentProductValue.vue?vue&type=script&lang=js"
export * from "./ParentProductValue.vue?vue&type=script&lang=js"

import "./ParentProductValue.vue?vue&type=style&index=0&id=f7a26824&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__